// Librerias
import React from 'react'
let PropTypes = React.PropTypes
import moment from 'moment'
moment.locale('es')
const format = 'YYYY-MM-DD'
// api
import api from '../apiClient/v1.js'
// Componentes
import SelectRange from '../components/shared/SelectRangeVirtualTable.jsx'
import { TablaUsuariosPendientes } from './tablaUsuariosPendientes.jsx'

export default class usuariosPendientes extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            fechaFinalSeleccionada: moment(),
            fechaInicialSeleccionada: moment().add(-7, 'days'),
            usuariosRAW: []
        }
    }
    componentWillMount(){
        this.buscarUsuariosPendienes()
        
    }
    
    onSelectRangoChanged(momentumFechaInicio, momentumFechaFinal){
        this.setState({
            fechaInicialSeleccionada: momentumFechaInicio,
            fechaFinalSeleccionada: momentumFechaFinal
        }, ()=>{
            let fechaInicio = this.state.fechaInicialSeleccionada.format('YYYY-MM-DD')
            let fechaFinal  = this.state.fechaFinalSeleccionada.format('YYYY-MM-DD')
            console.log(`rango seleccionado ${fechaInicio} al ${fechaFinal}`)
            // se llama al metodo seleccionar semana, que hace lo mismo
            this.buscarUsuariosPendienes(fechaInicio, fechaFinal)
        })
    }
    
    buscarUsuariosPendienes(){
        let fechaInicio = this.state.fechaInicialSeleccionada.format(format)
        let fechaFin = this.state.fechaFinalSeleccionada.format(format)

        api.nominas.usuariosPendientes(fechaInicio, fechaFin)
            .then(nominas=>{
                this.setState({usuariosRAW: nominas})
            })

    }
    render() {
        let fechaInicial = this.state.fechaInicialSeleccionada.format(format)
        let fechaFinal = this.state.fechaFinalSeleccionada.format(format)
        return(
            <div className={'container-fluid'}>
                <h1>Usuarios pendientes a agregar</h1>
                <div className={'row'}>
                    {/* SELECTOR UN RANGO DE FECHAS */}
                    <div className={'col-sm-4 form-group '}>
                        <label className="control-label" htmlFor="selectSemana">Rango de Fecha</label>
                        <SelectRange
                            startDateSelected = {this.state.fechaInicialSeleccionada}
                            endDateSelected = {this.state.fechaFinalSeleccionada}
                            onInit={()=>{console.log("on init")}}
                            onRangeSelected = {this.onSelectRangoChanged.bind(this)}
                        />
                    </div>
                </div>

                <div className={'row'}>
                    <div className={'col-md-9'}>
                        <TablaUsuariosPendientes
                            usuariosPendientes={this.state.usuariosRAW}
                        />
                    </div>
                </div>
            </div>
        )    
    }
}
usuariosPendientes.propTypes = {
    clientes: PropTypes.array
}



// WEBPACK FOOTER //
// ./frontEnd/usuariosPendientes/usuariosPendientes.jsx